import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

// TODO: padronizar 'apontamentoHeaderReport' para remover este arquivo.
export default function HeaderReport(visita, indicador, apontamento, params, optLabelConformidade) {
    // pdf do laudo, ou melhor, pdf da visita
    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;
    if (!params) {
        return null;
    }

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;
    const statusTamToletesPicados = IndicadorClass.getConformidadeStatus(
        apontamento.tamToletesPicados,
        params.tamToletesPicados,
    );
    const statusEntrenosRachados = IndicadorClass.getConformidadeStatus(
        apontamento.entrenosRachados,
        params.entrenosRachados,
    );
    const statusNosRachados = IndicadorClass.getConformidadeStatus(apontamento.nosRachados, params.nosRachados);
    const statusGemasDanificadas = IndicadorClass.getConformidadeStatus(
        apontamento.gemasDanificadas,
        params.gemasDanificadas,
    );
    const statusPalmitoAgregado = IndicadorClass.getConformidadeStatus(
        apontamento.palmitoAgregado,
        params.palmitoAgregado,
    );

    if (_.isEmpty(params)) {
        return h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra)
                ),

                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                ),
            ],
            { widths: [60, "*"] },
        );
    }

    const content = [
        h.panel([h.row(h.title("Amostra"), h.text(nomeAmostra), h.title("Tipo"), h.textField("tipo"))], {
            widths: [60, "*", 60, 70],
        }),

        (() => {
            const titleAr = [h.title("Talhão"), h.title("Área (ha)")];
            const valueAr = [h.text(getTalhaoNomeDisplay(apontamento)), h.text(getTalhaoAreaDisplay(apontamento))];
            const tamAr = ["*", "*"];

            if (apontamento.variedade) {
                titleAr.push(h.title("Variedade"));
                valueAr.push(h.textField("variedade.variedade"));
                tamAr.push("*");
            }

            if (apontamento.corte) {
                titleAr.push(h.title("Corte"));
                valueAr.push(h.textField("corte"));
                tamAr.push("*");
            }

            titleAr.push(h.title("Frota"), h.title("Frente"), h.title("Turno"));
            valueAr.push(h.textField("trator.numeroFrotaTrator"), h.textField("frente"), h.textField("turno"));
            tamAr.push("*", "*", "*");

            return h.panel([h.row(titleAr), h.row(valueAr)], { widths: tamAr });
        })(),

        h.panel([
            // prettier-ignore
            h.row(
                h.title("COLETAS")
            ),
        ]),

        h.panel([h.row(h.title("Observação"), h.text(params.obs))], { widths: [60, "*"] }),

        h.panel(
            [
                h.row(h.title("Parametros"), h.title("Avaliado"), h.title("Conforme"), h.title("%")),

                h.row(
                    h.text("Tamanho dos Toletes Picados"),
                    h.text(apontamento.totalAvaliadoTamToletesPicados),
                    h.text(apontamento.totalConformeTamToletesPicados),
                    h.conformidadeField("tamToletesPicados", statusTamToletesPicados, { alignment: "left" }),
                ),

                h.row(
                    h.text("Entrenós Rachados"),
                    h.text(apontamento.totalAvaliadoEntrenosRachados),
                    h.text(apontamento.totalConformeEntrenosRachados),
                    h.conformidadeField("entrenosRachados", statusEntrenosRachados, { alignment: "left" }),
                ),

                h.row(
                    h.text("Nós Rachados"),
                    h.text(apontamento.totalAvaliadoNosRachados),
                    h.text(apontamento.totalConformeNosRachados),
                    h.conformidadeField("nosRachados", statusNosRachados, { alignment: "left" }),
                ),

                h.row(
                    h.text("Gemas Danifcadas"),
                    h.text(apontamento.totalAvaliadoGemasDanificadas),
                    h.text(apontamento.totalConformeGemasDanificadas),
                    h.conformidadeField("gemasDanificadas", statusGemasDanificadas, { alignment: "left" }),
                ),

                h.row(
                    h.text("Palmito Agregado"),
                    h.text(apontamento.totalAvaliadoPalmitoAgregado),
                    h.text(apontamento.totalConformePalmitoAgregado),
                    h.conformidadeField("palmitoAgregado", statusPalmitoAgregado, { alignment: "left" }),
                ),
            ],
            { widths: [130, 60, 70, 30, "*"] },
        ),
    ];

    return h.unbreakable(content);
}
